/**
 * Route for `applovin-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApplovinIntegrationPage } from "../features/applovin-integration/ApplovinIntegrationPage";

export const applovinIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/applovin-integration",
	component: ApplovinIntegrationPage,
});

export default applovinIntegrationRoute;
